import { Edge, Node } from "@xyflow/react";

import { apiResponseMiddleware } from "@/middleware/api-response";
import toast from "react-hot-toast";

import { WorkFlowNodeType } from "@/types/workflow/node";
import { WorkflowType } from "@/types/workflow/workflow";

import { api } from "./axios-instance";
import { NodeSequenceType } from "@/types/workflow/nodeSequence";



const API_ENDPOINT = "/api/WorkFlow";

export const getAllWorkflows = async ({
  page,
  size,
  search
}: {
  page: number;
  size: number;
  search: string
}) =>
  await apiResponseMiddleware<WorkflowType[]>(
    api.get(`${API_ENDPOINT}/all`, {
      params: {
        pageSize: size,
        pageNumber: page,
        search: search || ""
      }
    }),
    () => { },
    {
      showToast: false
    }
  );

export const getWorkflow = async (workflowId: number) => {
  return await apiResponseMiddleware<WorkflowType>(
    api.get(`${API_ENDPOINT}/${workflowId}`),
    () => { },
    {
      showToast: false
    }
  );
};

export const createWorkflow = async (workflow: Partial<WorkflowType>) => {
  return await apiResponseMiddleware<WorkflowType>(
    api.post(`${API_ENDPOINT}/create`, workflow),
    () => {
      toast.success("گردش کار با موفقیت ساخته شد", {
        id: "api-middleware"
      });
    },
    {
      showToast: true
    }
  );
};

export const editWorkflow = async (
  workflowId: number,
  workflow: WorkflowType
) => {
  return await apiResponseMiddleware<WorkflowType>(
    api.post(`${API_ENDPOINT}/update`, {
      ...workflow,
      id: workflowId
    }),
    () => {
      toast.success("گردش کار با موفقیت ویرایش شد", {
        id: "api-middleware"
      });
    },
    {
      showToast: true
    }
  );
};

export const deleteWorkflow = async (workflowId: number) => {
  return await apiResponseMiddleware<WorkflowType>(
    api.post(`${API_ENDPOINT}/remove`, JSON.stringify(workflowId), {
      headers: {
        "Content-Type": "application/json"
      }
    }),
    () => {
      toast.success("گردش کار با موفقیت حذف شد", {
        id: "api-middleware"
      });
    },
    {
      showToast: true
    }
  );
};

export const saveWorkflowNodes = async (
  workflowId: number,
  data: { nodes: Node[]; edges: Edge[] }
) => {
  return await apiResponseMiddleware<null>(
    api.post(`${API_ENDPOINT}/setNodes`, {
      ...data,
      id: workflowId
    }),
    () => {
      toast.success("گردش کار با موفقیت ذخیره شد", {
        id: "api-middleware"
      });
    },
    {
      showToast: true
    }
  );
};

export const getNodeStates = async (WorkFlowUserId: string) => {
  return await apiResponseMiddleware<WorkFlowNodeType>(
    api.get(`${API_ENDPOINT}/nodeState`, {
      params: {
        WorkFlowUserId
      }
    }),
    () => {
      toast.success("فرم با موفقیت تغییر کرد", {
        id: "api-middleware"
      });
    },
    {
      showToast: false
    }
  );
};

export interface FormInput {
  tableId?: number | null;
  lable?: string | null;
  value?: string | null;
}

// تابع nodeStateMove را به صورت زیر تغییر دهید:
export const nodeStateMove = async (
  workflowUserId: string,
  state: number,
  nodeId?: string | null,
  newWorkflowUserId?: string | null,
  edgeIndex?: number | null,
  formDataInput?: {
    FormInputs: {
      tableId: number;
      lable: string;
      value?: string;
    }[];
  }
) => {

  const uniqueFormInputs = Array.from(
    new Map(
      (formDataInput?.FormInputs ?? [])
        .filter(
          (fi) =>
            fi.value !== undefined &&
            fi.value !== null &&
            fi.value.toString().trim() !== ""
        )
        .map((fi) => [
          `${fi.tableId}_${fi.lable}_${fi.value?.trim()}`,
          {
            ...fi,
            value: fi.value?.trim(),
          },
        ])
    ).values()
  );

  return await apiResponseMiddleware(
    api.post(`${API_ENDPOINT}/nodeMove`, {
      WorkflowUserId: workflowUserId,
      state,
      nodeId,
      newWorkflowUserId,
      edgeIndex,
      FormInputs: uniqueFormInputs,
    }),
    () => { },
    { showToast: false }
  );
};

export const getAllWorkflowNodes = async ({
  page,
  size
}: {
  page: number;
  size: number;
}) =>
  await apiResponseMiddleware<any[]>(
    api.get(`${API_ENDPOINT}/nodes/all`, {
      params: {
        pageSize: size,
        pageNumber: page
      }
    }),
    () => { },
    {
      showToast: false
    }
  );

export const getWorkflowStartNodes = async (workflowId: number) => {
  return await apiResponseMiddleware<any[]>(
    api.get(`${API_ENDPOINT}/${workflowId}/startNodes`),
    () => { },
    {
      showToast: false
    }
  );
};
export const getNodeSequence = async (workflowUserId: string) => {
  return await apiResponseMiddleware<NodeSequenceType[]>(
    api.get(`${API_ENDPOINT}/getNodeSequence`, {
      params: {
        workflowUserId
      }
    }),
    () => { },
    {
      showToast: false
    }
  );
};